import { Action } from "redux";

import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

/////////////////////////////////////////////////////////////////////
// Forum Categories Load

export const FORUM_CATEGORIES_FETCH_TRIGGER = "FORUM_CATEGORIES_FETCH_TRIGGER";
export interface ForumCategoriesFetchTriggerAction extends Action {
    readonly type: typeof FORUM_CATEGORIES_FETCH_TRIGGER;
}
export const FORUM_CATEGORIES_FETCH_REQUEST = "FORUM_CATEGORIES_FETCH_REQUEST";
export interface ForumCategoriesFetchRequestAction extends APIRequestAction {
    readonly type: typeof FORUM_CATEGORIES_FETCH_REQUEST;
}
export interface ForumCategoriesFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        categories: number[];
        activeDaysWithTopic: number;
        contestsTopic: number;
        testingsTopic: number;
        counsellingCategory: number;
        followingTopics: number[];
        numTopicsInCategory: { [categoryId: number]: number };
        numGroupsInCategory: { [categoryId: number]: number };
    };
}
export const FORUM_CATEGORIES_FETCH_SUCCESS = "FORUM_CATEGORIES_FETCH_SUCCESS";
export interface ForumCategoriesFetchSuccessAction extends APISuccessAction<ForumCategoriesFetchNormalizedResponse> {
    readonly type: typeof FORUM_CATEGORIES_FETCH_SUCCESS;
}
export const FORUM_CATEGORIES_FETCH_FAILURE = "FORUM_CATEGORIES_FETCH_FAILURE";
export interface ForumCategoriesFetchFailureAction extends APIFailureAction {
    readonly type: typeof FORUM_CATEGORIES_FETCH_FAILURE;
}

export const forumCategoriesFetchTrigger = (): ForumCategoriesFetchTriggerAction => ({
    type: FORUM_CATEGORIES_FETCH_TRIGGER,
});
export const forumCategoriesFetch = {
    request: (): ForumCategoriesFetchRequestAction => ({
        type: FORUM_CATEGORIES_FETCH_REQUEST,
    }),
    success: (
        response: ForumCategoriesFetchNormalizedResponse,
    ): ForumCategoriesFetchSuccessAction => ({
        type: FORUM_CATEGORIES_FETCH_SUCCESS,
        response,
    }),
    failure: (error: string): ForumCategoriesFetchFailureAction => ({
        type: FORUM_CATEGORIES_FETCH_FAILURE,
        error,
    }),
};
